import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import api from "../utils/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyOtp() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();

    const email = location.state?.email || localStorage.getItem("verify_email");
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!email) navigate("/register");
    }, [email, navigate]);

    const handleVerify = async (e) => {
        if (e) e.preventDefault();
        if (otp.length < 4) return;

        setLoading(true);
        try {
            const res = await api.post("/auth/verify-email", {
                email,
                otp: otp.trim(), // Sent exactly as typed (case-sensitive)
            });

            localStorage.setItem("AURÉNE_token", res.data.token);
            localStorage.setItem("AURÉNE_user", JSON.stringify(res.data.user));
            setUser(res.data.user);
            localStorage.removeItem("verify_email");

            navigate("/EntryPage");
        } catch (err) {
            alert(err.response?.data?.message || "Verification failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-lux-bg px-6">
            {/* Brand Header */}
            <div className="absolute top-12 text-center w-full">
                <span className="font-display text-2xl text-lux-primary tracking-[0.25em]">
                    AURÉNE
                </span>
            </div>

            <div className="w-full max-w-md bg-white p-10 lg:p-14 shadow-[0_40px_80px_rgba(0,0,0,0.06)] border border-gray-50">
                <div className="text-center mb-12">
                    <p className="label-sm text-lux-gold mb-3 tracking-[0.2em] uppercase">Security</p>
                    <h1 className="font-display text-4xl text-lux-primary mb-4">Final Step</h1>
                    <p className="font-sans text-sm text-lux-secondary leading-relaxed">
                        Please enter the case-sensitive code sent to <br />
                        <span className="text-lux-primary font-medium underline underline-offset-4 decoration-lux-gold/30">
                            {email}
                        </span>
                    </p>
                </div>

                <form onSubmit={handleVerify} className="space-y-10">
                    <div className="relative group">
                        <input
                            type="text"
                            maxLength="8" // Increased slightly just in case
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)} // Allows small and caps
                            placeholder="Code"
                            className="w-full bg-gray-50/50 border-b border-gray-200 focus:border-lux-gold focus:bg-transparent outline-none py-5 text-center text-3xl tracking-[0.3em] font-mono transition-all duration-500 placeholder:text-gray-200"
                            autoFocus
                            spellCheck="false"
                            autoComplete="one-time-code"
                        />
                        <div className="absolute left-0 right-0 -bottom-8 text-center">
                            <span className="text-[9px] uppercase tracking-[0.2em] text-gray-400 opacity-0 group-focus-within:opacity-100 transition-opacity">
                                Matches capitals and small letters
                            </span>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={loading || otp.length < 4}
                        className="btn-primary w-full py-4 relative disabled:opacity-50"
                    >
                        <span className="tracking-[0.2em] uppercase text-xs">
                            {loading ? "Verifying..." : "Verify & Enter"}
                        </span>
                    </button>
                </form>

                <div className="mt-16 text-center">
                    <button className="text-[10px] text-lux-secondary uppercase tracking-widest hover:text-lux-gold transition-colors">
                        Resend Code
                    </button>

                    <div className="mt-8 border-t border-gray-100 pt-8">
                        <Link
                            to="/register"
                            className="text-[9px] uppercase tracking-[0.2em] text-gray-400 hover:text-lux-primary transition-colors"
                        >
                            Back to Sign Up
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}